var _defs, _g, _circle, _circle2, _circle3, _g2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrebroWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 594.6 118.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.89,438.7v7.83H445.25V395.39h8.39V438.7Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.24,407.06v39.45H513.7l-.79-4.8a19.77,19.77,0,0,1-14.3,5.78c-11.76,0-20.54-8.88-20.54-20.71s8.78-20.66,20.54-20.66A19.87,19.87,0,0,1,513,412l.94-4.93Zm-8.13,19.72a12.9,12.9,0,1,0-12.87,13A12.53,12.53,0,0,0,512.11,426.78Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M552.69,406.18c9.22,0,15,6.88,15,16.59v23.76h-8.1V424.42c0-7.16-3.12-11-9.05-11-6.2,0-10.6,5-10.6,12v21.12h-8.11V407.08h5.65l1.58,5.5a16.68,16.68,0,0,1,13.65-6.4Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.73,434h7.92c.21,4.17,3.71,6.35,8.47,6.35,4.35,0,7.7-1.84,7.7-5.14,0-3.74-4.23-4.59-9.06-5.41-6.58-1.13-14.32-2.62-14.32-11.76,0-7.08,6.12-11.92,15.29-11.92s15.11,5,15.27,12.64h-7.68c-.16-3.76-3-5.77-7.78-5.77-4.48,0-7.25,1.91-7.25,4.79,0,3.48,4,4.17,8.78,5,6.67,1.12,14.76,2.4,14.76,12.13,0,7.66-6.38,12.63-16,12.63S575.94,442.19,575.73,434Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.27,439.16v7.37h-6c-8.64,0-14-5.33-14-14V414h-7.06v-1.57l13.72-14.59h1.38v9.21h11.74V414H626.37v17.81c0,4.7,2.62,7.32,7.4,7.32Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M668.58,406.86v7.66H664.3c-6.71,0-10,3.83-10,11v21h-8.11V407.08h5.48l1.37,5.38c2.83-3.74,6.7-5.6,12.08-5.6Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M713.1,407.06v39.45h-6.54l-.79-4.8a19.79,19.79,0,0,1-14.31,5.78c-11.75,0-20.54-8.88-20.54-20.71s8.79-20.66,20.54-20.66A19.84,19.84,0,0,1,705.89,412l1-4.93ZM705,426.78a12.9,12.9,0,1,0-12.87,13A12.53,12.53,0,0,0,705,426.78Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M747,414.2H735.88v32.33h-8.11V414.2h-7.38v-6.74h7.4v-3.34c0-8.06,4-12.51,12.6-12.51H747v6.46h-5c-4.39,0-6.3,1.84-6.3,6.23v3.16H747Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M753.82,407.08h8.1v39.45h-8.1Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M787.3,429.7h-4.91v16.83h-8.11V392.94h8.11v29.39h5L798,407.08h9.61L794.27,426,809,446.53h-9.91Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.12,426.9a26.54,26.54,0,0,1-.16,2.66h-32c1,6.39,5.61,10.32,12.07,10.32a11.86,11.86,0,0,0,10.62-5.77h8.53A19.94,19.94,0,0,1,831,447.49c-11.53,0-20.26-8.9-20.26-20.69s8.71-20.68,20.26-20.68c12.08,0,20.11,9.3,20.11,20.78Zm-32-3.93H843c-1.45-6-6-9.53-12-9.53A11.65,11.65,0,0,0,819.14,423Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.62,406.18c9.22,0,15,6.88,15,16.59v23.76h-8.1V424.42c0-7.16-3.12-11-9.06-11-6.19,0-10.59,5-10.59,12v21.12h-8.11V407.08h5.65l1.58,5.5a16.68,16.68,0,0,1,13.65-6.4Z",
    transform: "translate(-301 -361.16)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 456.87,
    cy: 35.66,
    r: 4.49
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 206.68,
    cy: 35.66,
    r: 4.49
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 191.24,
    cy: 35.66,
    r: 4.49
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44.45 41.38 34.67 41.38 34.67 79.6 58.49 79.6 58.49 70.87 44.45 70.87 44.45 41.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.49,432v8.72H335.67V402.53h9.78V432Z",
    transform: "translate(-301 -361.16)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.35 79.6 77.04 79.6 77.04 49.93 87.76 49.93 87.76 41.38 56.64 41.38 56.64 49.93 67.35 49.93 67.35 79.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.64,402.53h31.12v8.56H378v29.66h-9.68V411.09H357.64Z",
    transform: "translate(-301 -361.16)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.07,383.83l-5.31,5.59a1.42,1.42,0,0,0-.09,1.84,48.38,48.38,0,0,1,9.86,27.37,48.92,48.92,0,0,1-49.19,50.62,48.27,48.27,0,0,1-26.7-8.4,1.42,1.42,0,0,0-1.83.19l-5.78,6.1a1.41,1.41,0,0,0,.19,2.12,59.49,59.49,0,0,0,81.06-85.34A1.46,1.46,0,0,0,405.07,383.83Z",
    transform: "translate(-301 -361.16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.33,372.1a48.49,48.49,0,0,1,30.19,7.81,1.4,1.4,0,0,0,1.79-.19l5.43-5.73a1.41,1.41,0,0,0-.2-2.13,59.48,59.48,0,0,0-81,85.36,1.42,1.42,0,0,0,2.13.09l5.87-6.19a1.41,1.41,0,0,0,.1-1.82,48.61,48.61,0,0,1,35.66-77.2Z",
    transform: "translate(-301 -361.16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrebroWhite);
export default __webpack_public_path__ + "static/media/orebro_white.16ca322394510a0ea863723860decbcb.svg";
export { ForwardRef as ReactComponent };